module.exports = __webpack_public_path__ + "img/PRC_PISX_AXIS_001_5.PRT.4cd3d235.png";